// «تو هم عضو شو» — بستنِ پیشنهاد و به‌خاطر سپردنش (WHOSUP-137).
//
// تصمیمِ صریح: پیشنهادِ ثبت‌نام نرم است — بعد از محتوای اصلی، بدونِ مودال،
// و اگر مهمان بستش دیگر برنمی‌گردد. «دیگر برنمی‌گردد» یعنی باید جایی یادش
// بماند؛ این‌جا همان جای مشترکِ هر دو اپ است.
import { storage } from '../platform.ts';

const KEY = 'joinPitch.hidden';

export async function getJoinPitchHidden(): Promise<boolean> {
  try {
    return (await storage().getItem(KEY)) === '1';
  } catch {
    return false;
  }
}

export function hideJoinPitch(): void {
  void storage().setItem(KEY, '1').catch(() => undefined);
}
